import React from 'react';

const NetworkMetrics = ({ metrics }) => {
  const { notes, zaps, moscowTime } = metrics;
  
  // Calculate ratios for color coding
  const noteRatio = notes.currentRate / notes.baseline;
  const zapRatio = zaps.currentRate / zaps.baseline;
  const moscowTimeRatio = moscowTime.current / moscowTime.baseline;
  
  return (
    <div className="space-y-4">
      <div className={`arcade-panel ${getMetricClass(noteRatio)}`} id="note-metrics">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-sm font-pixel">NOTE ACTIVITY</h3>
          <div className="flex space-x-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div 
                key={i} 
                className={`w-2 h-2 ${i <= Math.min(Math.ceil(noteRatio * 5), 5) ? 'bg-primary-400' : 'bg-dark-600'}`}
              />
            ))}
          </div>
        </div>
        <div className="font-mono text-lg text-primary-300">{notes.currentRate.toFixed(1)} notes/min</div>
        <div className="text-xs mt-2 text-primary-200 font-mono">
          Regular notes created on the network.
          Feeds Nostrie's hunger.
        </div>
      </div>
      
      <div className={`arcade-panel ${getMetricClass(zapRatio)}`} id="zap-metrics">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-sm font-pixel">ZAP ENERGY</h3>
          <div className="flex space-x-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div 
                key={i} 
                className={`w-2 h-2 ${i <= Math.min(Math.ceil(zapRatio * 5), 5) ? 'bg-accent-400' : 'bg-dark-600'}`}
              />
            ))}
          </div>
        </div>
        <div className="font-mono text-lg text-accent-300">{zaps.currentRate.toFixed(0)} sats/min</div>
        <div className="text-xs mt-2 text-accent-200 font-mono">
          Satoshi value of zaps flowing through the network.
          Provides Nostrie's energy.
        </div>
      </div>
      
      <div className={`arcade-panel ${getMetricClass(moscowTimeRatio)}`} id="moscow-metrics">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-sm font-pixel">MOSCOW TIME</h3>
          <div className="flex space-x-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div 
                key={i} 
                className={`w-2 h-2 ${i <= Math.min(Math.ceil(moscowTimeRatio * 5), 5) ? 'bg-warning-400' : 'bg-dark-600'}`}
              />
            ))}
          </div>
        </div>
        <div className="font-mono text-lg text-warning-300">{moscowTime.current.toFixed(0)} sats/USD</div>
        <div className="text-xs mt-2 text-warning-200 font-mono">
          Current exchange rate in sats per USD.
          Affects Nostrie's happiness.
        </div>
      </div>
    </div>
  );
};

// Helper function to determine CSS class based on ratio
function getMetricClass(ratio) {
  if (ratio <= 0.5) {
    return 'border-danger-500 bg-dark-800';
  } else if (ratio <= 0.7) {
    return 'border-warning-500 bg-dark-800';
  } else if (ratio >= 1.5) {
    return 'border-success-500 bg-dark-800';
  } else if (ratio >= 1.0) {
    return 'border-primary-500 bg-dark-800';
  } else {
    return 'border-accent-500 bg-dark-800';
  }
}

export default NetworkMetrics; 